/* global sessionStorage */
const axios = require('axios')

function getHeaders () {
  return { 'Content-Type': 'application/json', "offset": getTimeOffset()  }
}

function getTimeOffset() {
  const offset = new Date().getTimezoneOffset();
  const absOffset = Math.abs(offset);
  const sign = offset > 0 ? '-' : '+';
  return `${sign}${absOffset}`;
}

function getStoredPublicIp () {
  try {
    return sessionStorage.getItem('loginIp') || ''
  } catch (err) {
    return ''
  }
}

function rememberPublicIp () {
  if (getStoredPublicIp()) return
  fetch('https://api.ipify.org?format=json')
    .then((r) => r.json())
    .then((data) => {
      const ip = String(data?.ip || '').trim()
      if (ip) sessionStorage.setItem('loginIp', ip)
    })
    .catch(() => {})
}
rememberPublicIp()

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // timeout: 1000,
  headers: getHeaders()
})

instance.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token')
  const publicIp = getStoredPublicIp()
  const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData
  config = {
    ...config,
    headers: {
      ...config.headers,
      ...(publicIp ? { 'x-client-public-ip': publicIp } : {}),
    }
  }
  // Let the browser set multipart boundary for file uploads
  if (isFormData && config.headers) {
    delete config.headers['Content-Type']
    delete config.headers['content-type']
  }
  if (!token) {
    const path = String(config.url || '')
    if (/\/(dashboard|check-notification)(\?|$)/.test(path)) {
      const silent = new Error('No session')
      silent.__noSession = true
      return Promise.reject(silent)
    }
    return config
  }
  if (!config.skipLoader) {
    const el = document.getElementById('loader')
    if (el) el.classList.remove('hidden')
  }
  config = {
    ...config,
    headers: { ...config.headers, Authorization: `Bearer ${token}` }
  }
  return config
})

function hideLoader () {
  const el = document.getElementById('loader')
  if (el) el.classList.add('hidden')
}

let sessionExpiring = false

function expireSession (message) {
  if (sessionExpiring) return
  sessionExpiring = true
  hideLoader()
  if (message) sessionStorage.setItem('ipSessionMessage', message)
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('refresh_token')
  sessionStorage.removeItem('uniqueId')
  sessionStorage.removeItem('userData')
  const path = window.location.pathname || ''
  if (path !== '/login' && path !== '/') {
    window.location.replace('/login')
  }
}

instance.interceptors.response.use(
  function (response) {
    hideLoader()
    return response
  },
  function (error) {
    hideLoader()
    if (error?.__noSession) {
      return Promise.resolve({ data: { success: false, results: {} } })
    }
    const status = error?.response?.status
    const data = error?.response?.data || {}
    const path = window.location.pathname || ''
    const onLogin = path === '/login' || path === '/'
    const geoKick = !!(
      data?.results?.ipNotWhitelisted ||
      data?.results?.countryBlocked ||
      data?.results?.blocked
    )
    const message =
      data?.message ||
      (data?.results?.countryBlocked || data?.results?.countryNotAllowed
        ? 'This country is not allowed. Contact your admin.'
        : 'IP is not whitelisted. Contact your admin.')
    // PREVIOUS: second 401 after token was cleared used Promise.reject and showed
    // CRA "Request failed with status code 401" overlay.
    if (status === 401 || status === 403 || status === 409) {
      if (onLogin) {
        return Promise.resolve({
          status: 200,
          data: data?.message
            ? data
            : { success: false, message, results: data?.results || {} },
        })
      }
      expireSession(geoKick || status === 401 || status === 403 ? message : '')
      return Promise.resolve({ data: { success: false, results: {} } })
    }
    return Promise.reject(error)
  }
)

function apiGet (url, params = {}, config = {}) {
  return instance.get(url, { params, ...config })
}

function apiPost (url, body, config = {}) {
  return instance.post(url, body, config)
}

/** Multipart upload helper (Pipedrive files/documents). */
function apiUpload (url, formData, config = {}) {
  return instance.post(url, formData, {
    ...config,
    headers: { ...(config.headers || {}), 'Content-Type': undefined },
  })
}

function apiPut (url, body) {
  return instance.put(url, body)
}

function apiPatch (url, body) {
  return instance.patch(url, body)
}

function apiDelete (url) {
  return instance.delete(url)
}

export { getHeaders, apiGet, apiPost, apiPut, apiDelete, apiPatch, apiUpload }
